import React, { useState } from "react";
import Button from "./Button";

const CallbackForm = () => {
  const buttonText = "Submit";
  const [formData, setFormData] = useState({
    name: "",
    age: "",
    gender: "",
    city: "",
    phoneNumber: "",
    retreatDateSuitability: "",
    retreatPriceSuitability: "",
    reasonToJoin: "",
    otherQuestion: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);

    const payload = {
      name: formData.name,
      age: formData.age,
      gender: formData.gender,
      city: formData.city,
      phone: formData.phoneNumber,
      date_suits: formData.retreatDateSuitability,
      price_suitable: formData.retreatPriceSuitability,
      reason: formData.reasonToJoin,
      question: formData.otherQuestion,
    };

    fetch("https://zbpje4azgliercmqvfqkh34bqm0mlmwm.lambda-url.ap-south-1.on.aws/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .catch((error) => {
        console.error("Error submitting form:", error);
        alert("⚠️ An error occurred. Please try again later.");
      })
      .finally(() => {
        setIsSubmitting(false);
        alert("✅ Form submitted successfully!");
        setFormData({
          name: "",
          age: "",
          gender: "",
          city: "",
          phoneNumber: "",
          retreatDateSuitability: "",
          retreatPriceSuitability: "",
          reasonToJoin: "",
          otherQuestion: "",
        });
      });
  };

  return (
    <div className="max-w-2xl mx-auto bg-white p-6 text-sm md:text-lg rounded-lg shadow-lg border border-gray-200 w-full sm:w-[90%] md:w-[80%]">
      {/* Heading and subtext */}
      <div className="mb-6 text-center">
        <h1 className="text-xl md:text-2xl font-bold text-secondary">Have a query?</h1>
        <p className="text-sm md:text-base text-gray-600">Fill this form to get a call back</p>
      </div>
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Name & Age */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={formData.name}
            onChange={handleChange}
            className="border p-2 rounded w-full text-sm focus:ring focus:ring-primary"
            required
          />
          <input
            type="number"
            name="age"
            placeholder="Age"
            value={formData.age}
            onChange={handleChange}
            min="18"
            max="99"
            className="border p-2 rounded w-full text-sm focus:ring focus:ring-primary"
            required
          />
        </div>

        {/* Gender & City */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <select
            name="gender"
            value={formData.gender}
            onChange={handleChange}
            className="border p-2 rounded w-full text-sm text-gray-400 focus:ring focus:ring-primary"
            required
          >
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
          <input
            type="text"
            name="city"
            placeholder="City"
            value={formData.city}
            onChange={handleChange}
            className="border p-2 rounded w-full text-sm focus:ring focus:ring-primary"
            required
          />
        </div>

        {/* Phone Number */}
        <input
          type="tel"
          name="phoneNumber"
          placeholder="Phone Number"
          value={formData.phoneNumber}
          onChange={handleChange}
          pattern="[0-9]{10}"
          className="border p-2 rounded w-full text-sm focus:ring focus:ring-primary"
          required
        />

        {/* Retreat Date & Price Suitability */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block font-semibold text-secondary text-sm">
              Does the retreat date suit you?
            </label>
            <select
              name="retreatDateSuitability"
              value={formData.retreatDateSuitability}
              onChange={handleChange}
              className="border p-2 rounded w-full text-sm focus:ring focus:ring-primary text-gray-400"
              required
            >
              <option value="">Select</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>

          <div>
            <label className="block font-semibold text-secondary text-sm">
              Is the retreat price suitable for you?
            </label>
            <select
              name="retreatPriceSuitability"
              value={formData.retreatPriceSuitability}
              onChange={handleChange}
              className="border p-2 rounded w-full text-sm focus:ring focus:ring-primary text-gray-400"
              required
            >
              <option value="">Select</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>
        </div>

        {/* Reason to Join */}
        <textarea
          name="reasonToJoin"
          placeholder="What’s your reason to join this retreat?"
          value={formData.reasonToJoin}
          onChange={handleChange}
          minLength="5"
          maxLength="100"
          className="border p-2 rounded w-full text-sm focus:ring focus:ring-primary"
          required
        ></textarea>

        {/* Other Questions */}
        <textarea
          name="otherQuestion"
          placeholder="Any other question?"
          value={formData.otherQuestion}
          onChange={handleChange}
          minLength="5"
          maxLength="100"
          className="border p-2 rounded w-full text-sm focus:ring focus:ring-primary"
        ></textarea>

        {/* Submit Button */}
        <div className="flex justify-center">
          <Button text={buttonText} type="submit" variant="primary" size="md" disabled={isSubmitting} />
        </div>
      </form>
    </div>
  );
};

export default CallbackForm;
